import React, { useEffect, useRef, useState } from 'react';
import { Modal, Button, Input, Typography, message, Alert, Row, Col, Card, Spin } from 'antd';
import Post from '../services/Post';
import { useSearchParams } from 'react-router-dom';
import Get from '../services/Get';
import { DownloadOutlined, PrinterOutlined } from '@ant-design/icons';
import logo from "../assets/images/logo.png";
import domtoimage from "dom-to-image";
import downloadjs from 'downloadjs';
import html2canvas from 'html2canvas';
import { useScreenshot, createFileName } from 'use-react-screenshot'

const { Title, Paragraph, Text } = Typography;

const Mahakumbh = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [referenceId, setReferenceId] = useState('');
    const [upiId, setUpiId] = useState('');
    const [txnNumber, setTxnNumber] = useState('');
    const [processing, setProcessing] = useState(false);
    const [loading, setLoading] = useState(true);
    const [submitted, setSubmitted] = useState(false);
    const [qrData, setQrData] = useState();
    const [qr, setQR] = useState();
    const [profile, setProfile] = useState();

    const [searchParams] = useSearchParams();
    const user_id = searchParams.get("user");
    const user = JSON.parse(localStorage.getItem('user'));
    const qrCodeRef = useRef();
    const [image, takeScreenshot] = useScreenshot({
        type: "image/jpeg",
        quality: 1.0
    })

    const handleOpenModal = () => setIsModalOpen(true);
    const handleCloseModal = () => {
        setIsModalOpen(false);
        setReferenceId('');
    };

    const handleSubmit = () => {
        setProcessing(true);
        const formData = {
            utr: referenceId,
            user_id,
            upi: upiId,
            txn_no: txnNumber
        };

        Post.RegisterMahakumbh(formData).then((res) => {
            if (res.error) {
                message.error(res.error);
            }
            else {
                getData();
                message.success("Registered Successfully!");
            }
        }).catch((err) => {
            message.error(err);
        }).finally(() => {
            setProcessing(false);
            handleCloseModal();
            getData();
        });
    };

    const handleDownload = () => {
        if (qrCodeRef.current) {
            domtoimage.toBlob(qrCodeRef.current, {
                cacheBust: true,
                bgcolor: 'white',
                useCORS: true, // Ensures images from other origins are included
            })
                .then((blob) => {
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = `${qrData.qr_code || 'unknown'}.png`;
                    link.click();
                })
                .catch((error) => {
                    console.error('Error generating image:', error);
                });
        }
    };

    const handlePrint = () => {
        if (qrCodeRef.current) {
            domtoimage.toPng(qrCodeRef.current)
                .then((dataUrl) => {
                    const newWindow = window.open('', '_blank');
                    newWindow.document.write(`
                        <html>
                            <head><title>Print Gate Pass</title></head>
                            <body style="text-align: center;">
                                <img src="${dataUrl}" style="width: 300px;" />
                                <script>window.onload = function() { window.print(); window.onafterprint = function() { window.close(); }; }</script>
                            </body>
                        </html>
                    `);
                    newWindow.document.close();
                })
                .catch((error) => console.error('Error generating print image:', error));
        }
    };

    const getData = () => {
        Get.Mahakumbh(user_id).then((res) => {
            console.log(res);
            
            if (res.data) {
                setQrData(res.data);
                setProfile(res.avatar);
                setQR(res.qr_code);
                setSubmitted(true);
            }
        }).catch((err) => message.error(err))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        setLoading(true);
        getData();
    }, []);

    return (
        <div style={{ textAlign: 'center', padding: '20px' }}>
            {loading ? (
                <Spin size="large" style={{ marginTop: '50px' }} />
            ) : (
                <>
                    {!qr && <img src="/mahakumbh.png" alt="Mahakumbh" style={{ width: '80%', marginBottom: '20px' }} />}
                    {!submitted ? (
                        <>
                            <Title level={2}>Mahakumbh-3: A Grand Educational Gathering</Title>
                            <Paragraph>
                                Join Mahakumbh-3, organized by the Bhartiya Shiksha Board and School Shiksha Parivaar Rajasthan.
                                This prestigious event, graced by Dr. Anil Sharma and Yoga Guru Baba Ramdev Ji,
                                aims to bring together educators, students, and thought leaders.
                            </Paragraph>
                            <Paragraph>
                                📅 <strong>Date:</strong> 16th February 2025<br />
                                ⏰ <strong>Time:</strong> 9:00 AM<br />
                                📍 <strong>Venue:</strong> Central Lawn, EP Jawahar Circle, Jaipur
                            </Paragraph>
                            <Paragraph><strong>Registration Fee:</strong> ₹400</Paragraph>
                            <Paragraph>
                                To join the campaign, complete your payment using the UPI details and get a Gate Pass.
                            </Paragraph>

                            <Button className='form-btn' onClick={handleOpenModal}>
                                Join Campaign
                            </Button>

                            <Modal
                                title="Transaction Details"
                                open={isModalOpen}
                                onCancel={handleCloseModal}
                                onOk={handleSubmit}
                                okButtonProps={{ className: 'form-btn', loading: processing }}
                            >
                                <Input
                                    value={referenceId}
                                    onChange={(e) => setReferenceId(e.target.value)}
                                    placeholder="Enter Reference ID / UTR"
                                    style={{ marginBottom: 10 }}
                                />
                                <Input
                                    value={upiId}
                                    onChange={(e) => setUpiId(e.target.value)}
                                    placeholder="Enter Your UPI ID"
                                    style={{ marginBottom: 10 }}
                                />
                                <Input
                                    value={txnNumber}
                                    onChange={(e) => setTxnNumber(e.target.value)}
                                    placeholder="Enter Transaction Number"
                                    style={{ marginBottom: 10 }}
                                />
                            </Modal>
                        </>
                    ) : (
                        <Row justify="center" align="middle" style={{ minHeight: '60vh' }}>
                            <Col>
                                {qrData.status === 'approved' && qrData.utr ? (
                                    <>
                                        <Card
                                            style={{
                                                width: 250,
                                                textAlign: 'center',
                                                borderRadius: 10,
                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                                padding: 10,
                                                backgroundColor: 'white'
                                            }}
                                            ref={qrCodeRef}
                                        >
                                            <img
                                                src={profile}
                                                alt="Profile"
                                                style={{
                                                    width: 140,
                                                    height: 140,
                                                    borderRadius: '50%',
                                                    objectFit: 'cover',
                                                }}
                                            />
                                            <Title level={4} style={{ marginTop: 10 }}>
                                                {qrData.qr_code}
                                            </Title>

                                            <div
                                                style={{
                                                    background: '#a6cc43',
                                                    color: 'white',
                                                    padding: '5px',
                                                    borderRadius: 5,
                                                    margin: '10px 0',
                                                }}
                                            >
                                                <Text style={{ fontSize: 16, fontWeight: 'bold', color: 'white' }}>
                                                    {user.name}
                                                </Text>
                                            </div>

                                            <Row>
                                                <Col span={12}>
                                                    <img src={qr} width={80} alt="QR Code" />
                                                </Col>
                                                <Col span={12}>
                                                    <Typography.Text strong style={{ fontSize: 14, color: 'red' }}>Mahakumbh 3</Typography.Text>
                                                    <img src={logo} width={110} alt="Logo" />
                                                </Col>
                                            </Row>
                                        </Card>

                                        <Row justify="center" gutter={16} style={{ marginTop: '30px' }}>
                                            <Col>
                                                <Button
                                                    type="default"
                                                    icon={<DownloadOutlined />}
                                                    className='form-btn'
                                                    onClick={handleDownload}
                                                >
                                                    Download
                                                </Button>
                                            </Col>
                                            <Col>
                                                <Button
                                                    type="primary"
                                                    icon={<PrinterOutlined />}
                                                    className='form-btn'
                                                    onClick={handlePrint}
                                                >
                                                    Print
                                                </Button>
                                            </Col>
                                        </Row>
                                    </>
                                ) : qrData.utr ? (
                                    <Alert
                                        message="Request Submitted"
                                        description="Your Gate Pass will be generated soon. Thanks for your patience."
                                        type="success"
                                        showIcon
                                    />
                                ) : (
                                    <Card
                                        style={{
                                            width: 250,
                                            textAlign: 'center',
                                            borderRadius: 10,
                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                            padding: 10,
                                            backgroundColor: 'white'
                                        }}
                                    >
                                        <Input
                                            value={referenceId}
                                            onChange={(e) => setReferenceId(e.target.value)}
                                            placeholder="Enter Reference ID / UTR"
                                            style={{ marginBottom: 10 }}
                                        />
                                        <Button className='form-btn' onClick={handleSubmit}>Submit</Button>
                                    </Card>
                                )}
                            </Col>
                        </Row>
                    )}
                </>
            )}
        </div>
    );
};

export default Mahakumbh;
